.loading-icon {
  width: 32px;
  height: 32px;
}
